import { render, staticRenderFns } from "./SendActivationCoverText.vue?vue&type=template&id=b3547974"
import script from "./SendActivationCoverText.vue?vue&type=script&lang=js"
export * from "./SendActivationCoverText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports